export default __webpack_public_path__ + "static/media/agent-illu2.2dbe7357.png";